import { render } from "./SurveyBoxStar.vue?vue&type=template&id=4c4d2d64&scoped=true"
import script from "./SurveyBoxStar.vue?vue&type=script&lang=js"
export * from "./SurveyBoxStar.vue?vue&type=script&lang=js"

import "./SurveyBoxStar.vue?vue&type=style&index=0&id=4c4d2d64&scoped=true&lang=css"

import exportComponent from "/home/devops/vsts-agent/_work/20/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4d2d64"]])

export default __exports__